"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../../../Button/Button"));
var fields_1 = require("../../../Form/fields");
var SelectTypPozastaveni_1 = __importDefault(require("../../../Form/fields/SelectTypPozastaveni"));
var Form_1 = __importDefault(require("../../../Form/Form"));
var Padder_1 = require("../../../Padder");
var ModalButtonsWrap_1 = __importDefault(require("../ModalButtonsWrap"));
var PopupHeader_1 = __importDefault(require("../PopupHeader"));
var validation = function (values) {
    var datumLens = ramda_1.lensProp('od');
    var typLens = ramda_1.lensProp('idTypPozastaveni');
    var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(datumLens, values); }, ramda_1.set(datumLens, 'Datum od je povinné')), ramda_1.when(function () { return !ramda_1.view(typLens, values); }, ramda_1.set(typLens, 'Důvod je povinný')))({});
    return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
};
var PozastaveniCinnostiForm = function (_a) {
    var onSubmit = _a.onSubmit, initialValues = _a.initialValues, headerText = _a.headerText, onZrusit = _a.onZrusit, disabled = _a.disabled;
    var initialOd;
    if (initialValues === null || initialValues === void 0 ? void 0 : initialValues.od) {
        initialOd = new Date(initialValues.od.toString());
    }
    var initialDo;
    if (initialValues === null || initialValues === void 0 ? void 0 : initialValues.do) {
        initialDo = new Date(initialValues.do.toString());
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { paddingLeft: '2rem', paddingTop: '2rem' } },
            react_1.default.createElement(PopupHeader_1.default, { style: { marginBottom: '0' } }, headerText)),
        react_1.default.createElement(Form_1.default, { initialValues: initialValues || {}, validate: validation, onSubmit: onSubmit }, function (_a) {
            var isSubmitting = _a.isSubmitting;
            return (!disabled || isSubmitting) && (react_1.default.createElement(Padder_1.Padder, null,
                react_1.default.createElement(fields_1.DateRangeField, { fromName: "od", fromLabel: "Datum od", toName: "do", toLabel: "Datum do", defaultOd: initialOd, defaultDo: initialDo, toolTipFrom: "Vyberte datum za\u010D\u00E1tku pozastaven\u00ED \u010Dinnosti", toolTipTo: "Vyberte datum ukon\u010Den\u00ED pozastaven\u00ED \u010Dinnosti" }),
                react_1.default.createElement(SelectTypPozastaveni_1.default, { label: "D\u016Fvod", name: "idTypPozastaveni", inputId: "SelectTypPozastaveni" }),
                react_1.default.createElement(ModalButtonsWrap_1.default, null,
                    react_1.default.createElement(Button_1.default, { type: "button", primary: false, loading: isSubmitting, onClick: onZrusit, name: "Zrusit" }, "Zru\u0161it"),
                    react_1.default.createElement(Button_1.default, { type: "submit", primary: true, loading: isSubmitting, name: "Ulozit" }, "Ulo\u017Eit"))));
        })));
};
PozastaveniCinnostiForm.defaultProps = {
    initialValues: undefined,
    disabled: false,
};
exports.default = PozastaveniCinnostiForm;
